import React from "react";

const Header = () => {
  return (
    <header>
      <nav>
        <a href="#about">ABOUT</a>
        <a href="#portfolio">QUALIFICATIONS</a>
        <a href="#projects">PROJECTS</a>
        <a href="#contact">CONTACT</a>
      </nav>
    </header>
  );
};

export default Header;
